import React from "react";
import AuthGuard from "./AuthGuard";
import Permission from "./Permission";
import { EyeOff, AlertCircle } from "lucide-react";
import usePermissions from "../hooks/usePermissions";

/**
 * PermissionRoute Component
 * Wraps routes with both authentication and permission checking
 */
const PermissionRoute = ({
  children,
  permission,
  fallbackTitle = "Access Restricted",
  fallbackMessage = "You don't have permission to access this page.",
}) => {
  const { userRole } = usePermissions();

  return (
    <AuthGuard>
      <Permission
        permission={permission}
        fallback={
          <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
              <EyeOff className="w-16 h-16 text-red-400 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-red-800 mb-2">
                {fallbackTitle}
              </h2>
              <p className="text-red-600 mb-6">{fallbackMessage}</p>

              <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-left">
                <div className="flex items-center mb-2">
                  <AlertCircle className="w-5 h-5 text-red-500 mr-2" />
                  <span className="font-medium text-red-700">
                    Permission Details
                  </span>
                </div>
                <p className="text-sm text-red-700 mb-1">
                  <strong>Your Role:</strong>{" "}
                  {userRole?.replace("_", " ").toUpperCase() || "Unknown"}
                </p>
                <p className="text-sm text-red-700">
                  <strong>Required Permission:</strong> {permission}
                </p>
              </div>

              <button
                onClick={() => window.history.back()}
                className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                Go Back
              </button>
            </div>
          </div>
        }
      >
        {children}
      </Permission>
    </AuthGuard>
  );
};

export default PermissionRoute;
